import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

const NationalityFilter = ({ nationalities, selectedNationality, onNationalityChange, showAll = true }) => {
  if (!nationalities || nationalities.length === 0) {
    return null
  }

  const handleNationalityClick = (nationalityId) => {
    if (onNationalityChange) {
      onNationalityChange(nationalityId === selectedNationality ? null : nationalityId)
    }
  }

  const getFlagUrl = (nationality) => {
    if (nationality?.attributes?.flag?.data?.attributes?.url) {
      return `https://panel.imigo.app${nationality.attributes.flag.data.attributes.url}`
    }
    return null
  }

  const getNationalityName = (nationality) => {
    return nationality?.attributes?.language || 'Unknown'
  }

  return (
    <Container className="mb-4">
      <Row>
        <Col xs={12}>
          <div className="nationality-filter">
            <h4 className="text-sm font-semibold text-darkgray mb-3">Filter by Nationality</h4>
            <div className="flex flex-wrap gap-2">
              {showAll && (
                <button
                  onClick={() => handleNationalityClick(null)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                    selectedNationality === null
                      ? 'bg-neonorange text-white'
                      : 'bg-lightgray text-darkgray hover:bg-gray-300'
                  }`}
                >
                  All Nationalities
                </button>
              )}
              {nationalities.map((nationality) => {
                const flagUrl = getFlagUrl(nationality)
                const name = getNationalityName(nationality)
                const isSelected = selectedNationality === nationality.id

                return (
                  <button
                    key={nationality.id}
                    onClick={() => handleNationalityClick(nationality.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                      isSelected
                        ? 'bg-neonorange text-white'
                        : 'bg-lightgray text-darkgray hover:bg-gray-300'
                    }`}
                  >
                    {flagUrl && (
                      <img
                        src={flagUrl}
                        alt={name}
                        className="w-5 h-5 object-cover rounded"
                        onError={(e) => {
                          e.target.style.display = 'none'
                        }}
                      />
                    )}
                    <span>{name}</span>
                  </button>
                )
              })}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

NationalityFilter.propTypes = {
  nationalities: PropTypes.array,
  selectedNationality: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onNationalityChange: PropTypes.func.isRequired,
  showAll: PropTypes.bool
}

export default NationalityFilter





